import { createApiRef } from '@backstage/frontend-plugin-api';
import {
  Account,
  Group,
  Project,
  User,
} from '@internal/backstage-plugin-catalog-devops-common';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';

export const adminApiRef = createApiRef<AdminApi>().with({
  id: 'admin-api',
  pluginId: 'catalog-devops',
});

export interface AdminApi {
  createGroupEntity(data: Group): Promise<DefaultApiResponse>;
  editGroupEntity(id: string, data: Group): Promise<DefaultApiResponse>;
  deleteGroupEntity(id: string): Promise<DefaultApiResponse>;
  createUserEntity(data: User): Promise<DefaultApiResponse>;
  editUserEntity(id: string, data: User): Promise<DefaultApiResponse>;
  deleteUserEntity(id: string): Promise<DefaultApiResponse>;
  createAccountEntity(data: Account): Promise<DefaultApiResponse>;
  editAccountEntity(id: string, data: Account): Promise<DefaultApiResponse>;
  deleteAccountEntity(id: string): Promise<DefaultApiResponse>;
  createProjectEntity(data: Project): Promise<DefaultApiResponse>;
  editProjectEntity(id: string, data: Project): Promise<DefaultApiResponse>;
  deleteProjectEntity(id: string): Promise<DefaultApiResponse>;
}
